import * as Sentry from '@sentry/react'
import { SENTRY_RELEASE_VERSION, SentryDSN, SentryENV } from '@/constants/appConfig'
import { isSentryEnabled } from '@/utils/sentry.utils'

if (isSentryEnabled() && SentryDSN) {
  Sentry.init({
    dsn: SentryDSN,
    environment: SentryENV,
    release: SENTRY_RELEASE_VERSION,
    integrations: [
      Sentry.browserTracingIntegration(),
      Sentry.replayIntegration(),
      Sentry.browserProfilingIntegration(),
    ],
    tracesSampleRate: 1.0,
    tracePropagationTargets: [window.location.hostname],
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    profilesSampleRate: 1.0,
  })
}
